module.exports = __webpack_public_path__ + "media/images/emblems/Gurmels-coat_of_arms-f8f510870c3d9656ff119183bb33caff.svg";